import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import FeatureTogglz from '@bibliocommons/feature-togglz';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import Divider from '@bibliocommons/divider';
import MoreFromNovelist from 'app/components/bibs/shared/MoreFromNovelist';
import { CommunityTagsContainer } from './CommunityTags';
import RelatedTitles from './RelatedTitles';
import SimilarSeries from './SimilarSeries';
import { SimilarAuthorsContainer } from './SimilarAuthors';
import { RelatedAuthorsContainer } from './RelatedAuthors';
import { OnlineResourcesContainer } from './OnlineResources';
import './Explore.scss';

export default class Explore extends React.PureComponent {
  render() {
    const { catalogBib, tags, authorSuggestions, relatedTitles, relatedAuthors, onlineResources } = this.props;
    const metadataId = catalogBib.get('metadataId');
    if (!tags.size && !authorSuggestions.size && !relatedTitles.size && !relatedAuthors.size && !onlineResources.size) {
      return null;
    }

    return (
      <div>
        <section className="cp-bib-explore container">
          <div className="row">
            <div className="col-lg-3">
              <FormattedMessage tagName="h2" id="explore_section" />
            </div>
            <div className="col-lg-7">
              <RelatedTitles />
              <OnlineResourcesContainer />
              <CommunityTagsContainer metadataId={metadataId} />
              <FeatureTogglz>
                {features => (features.get(TOGGLZ_FEATURES.NERF_BIB_PAGE_DEVELOPMENT) ? <SimilarSeries /> : null)}
              </FeatureTogglz>
              {authorSuggestions.size || relatedAuthors.size ? (
                <div className="more-authors">
                  <SimilarAuthorsContainer />
                  <RelatedAuthorsContainer />
                </div>
              ) : null}
              <MoreFromNovelist
                catalogBib={catalogBib}
                heading={<FormattedMessage tagName="h3" id="more_about_this_title" />}
              />
            </div>
          </div>
        </section>
        <div className="container">
          <Divider />
        </div>
      </div>
    );
  }
}

Explore.propTypes = {
  catalogBib: catalogBibShape.isRequired,

  // Props below are used to conditionally render section title
  tags: ImmutablePropTypes.list.isRequired,
  relatedTitles: ImmutablePropTypes.list.isRequired,
  authorSuggestions: ImmutablePropTypes.list.isRequired,
  relatedAuthors: ImmutablePropTypes.list.isRequired,
  onlineResources: ImmutablePropTypes.list.isRequired
};
